import React, { Component } from "react";
import { Redirect, Route } from "react-router-dom";
import { Switch } from 'react-router'
import { Container } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import classnames from "classnames";
import Header from "./Header";
import MobileMenu from "./MobileMenu";
import { store } from "../../store";
import {
  setUserDetails,
  setPortfolio,
  clearPortfolio,
  clearOnboarding,
  setUserPanlessHoldings,
  setBse,
  setAppConfig,
  setShoppingGoals,
  setAmazonGoalData,
  setRiskProfile,
  setUserState,
  setOnboardingDataForAddPan,
  setOnboardingKycDetails,
  setTransactionState,
  getObTPD,
} from "../../actions";
import { userProfileService } from "../../user/services/profile";
import { userProfileHelpers } from "../../user/helpers/profile";
import { portfolioService } from "../../portfolio/services/portfolio";
import { portfolioHelpers } from "../../portfolio/helpers/portfolio";
import { authService } from "../../auth/services/auth";
import { versionService } from "../services/version";
import { middlewareService } from "../../shared/service";
import middlewareConstants from "../../shared/middleware-constant";
import { Helpers as BseHelpers } from "../../shell/components/onboarding/bse/halper/index";
import { esigningUrl } from "../../shell/components/onboarding/bse/utilities/esign";
import { festGoalsService } from "./dashboard/festival/services/festGoalsService";
//import { riskService } from "../../risk-profile/service/index";
import { userService } from "../../user/services/user";
import OrobondsProfile from "../../waitlist/components/OrobondsProfile";
import OrobondsAsset from "../../waitlist/components/OrobondsAsset";
import WaitlistDocsUpMain from "../../waitlistDocVault/WaitlistDocsUpMain"
import OrobondsPortfolioMain from "../../waitlist/components/OrobondsPortfolioMain";
import ObInvestmentOpportunitiesMain from "../../waitlist/components/ObInvestmentOpportunitiesMain";
import OrobondsFaqs from "../../waitlist/components/OrobondsFaqs";
import { getThirdPartyData, getUserEmailApi } from "../../waitlist/services/waitlist-service";
import { getConsolidatedPortfolio } from "../../waitlist/services/waitlist-service";
import OrobondsMain from "../../waitlist/components/OrobondsMain";
// import { Mixpanel } from "../../waitlist/components/MixPanel";
import TagManager from 'react-gtm-module';
import ReactGA from "react-ga4";
import ReferMain from "../../waitlist/components/ReferMain";
import LiquidationMain from "../../waitlist/components/LiquidationMain";
import SeprateFaq from "../../waitlist/components/OrobondsFaq";
import ReferDashboard from "../../waitlist/components/ReferDashboard";
import ReferralDashboardMain from "../../referral/component/ReferralDashboardMain";
// import ReactPixel from 'react-facebook-pixel';
import IncReports from "../../waitlist/components/IncReports";
import { getRedeemRequests } from "../../waitlist/services/waitlist-service";
import UserProfileDrawerBse from "../../user/components/UserProfileDrawerBse";
import MainLoader from "../../core/components/MainLoader";
import { utils } from "../../core/helpers/utils";
class AppShell extends Component {
  constructor(props) {
    super(props);

    this.state = {
      portfolioDetails: {},
      isProfileDrawerOpen: false,
      isAllPansSelected: false,
      version: "",
      modal: false,
      portfolioErr:
        "We are experiencing heavy traffic as of now. Please reload (Ctrl+Shift+R) or try again later.",
      isOrobonds: false,
      isAltAsset: false,
      userEmail: "",
      name: "",
      isNativeView: false,
      phone: "",
      showContent: true, // New state variable to control content visibility
      loading: false,
      homeloading: false,
      pan : "",
    };

    this.onUserProfileClicked = this.onUserProfileClicked.bind(this);
    this.onUserProfileCloseClicked = this.onUserProfileCloseClicked.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
    this.openPortfolioModal = this.openPortfolioModal.bind(this);
    this.closePortfolioModal = this.closePortfolioModal.bind(this);
    this.openViewMfModal = this.openViewMfModal.bind(this);
    this.closeViewMfModal = this.closeViewMfModal.bind(this);
    this.loadAllData = this.loadAllData.bind(this);
    this.setDefaultPan = this.setDefaultPan.bind(this);
    this.onOnboardingClosed = this.onOnboardingClosed.bind(this);
    this.showMsg = this.showMsg.bind(this);
    this.fetchTransactions = this.fetchTransactions.bind(this);
    this.toggle = this.toggle.bind(this);
    this.showErrorMsg = this.showErrorMsg.bind(this);
    this.fetchPortfolioSummary = this.fetchPortfolioSummary.bind(this);
    this.setUiConfig = this.setUiConfig.bind(this);
    this.closeConsultBanner = this.closeConsultBanner.bind(this);
    this.handleLogoClick = this.handleLogoClick.bind(this);
    this.handleReferClick = this.handleReferClick.bind(this);
    this.handlePortfolioClick = this.handlePortfolioClick.bind(this);
    this.handleFaqClick = this.handleFaqClick.bind(this);
    window.$isAmazon = process.env.REACT_APP_AMAZON_DASHBOARD === "true";
  }

  componentDidMount() {
    TagManager.initialize({ gtmId: 'GTM-K74D524' });
    ReactGA.initialize("G-LSFGC6PR9L");

    /* ReactPixel.init('1613991859107974');
    ReactPixel.pageView(); */
    
    if (window.ReactNativeWebView) {
      this.setState({isNativeView: true});
    }
    this.setUiConfig();
    this.onComponentMount();
    getConsolidatedPortfolio().then((result) => {
      const response = utils.parsePayload(result);
      if (!response || !response.success) {
        return toast.error('something went wrong while fetching OB investment');
      } else {
        if (response?.data?.consolidated?.investedAmt > 0) {
          this.setState({
            isUserObInvested: true
          });
          this.setState({portfolioDetails: response.data})
        } else if (response?.data?.holdings && Object.keys(response?.data?.holdings).length ) {
          this.setState({
            isUserObInvested: true
          });
        } else {
          this.setState({
            isUserObInvested: false
          });
        } 
      }
    });
    getUserEmailApi({"X-product": 'orobonds:default', 'x-encrypted-data': true})
    .then((result) => {
      const response = utils.parsePayload(result);
      
      if (response && response.success) {
        this.setState({
          userType: response.userType
        })
      }
    });
    getRedeemRequests().then((res) => {
      if (!res.success) {
        return null
      } 
      if (res && res.success && res.data && res.data.length) {
        this.setState({ isUserObInvested: true });
      } else {
        this.setState({
          isUserObInvested: false
        });
      }
    }
    );
    window.onhashchange = () => {
      this.onComponentMount();
    };

    if (!localStorage.getItem("showBanner")) {
      localStorage.setItem("showBanner", "true");
        this.setState({showConsultbanner: true});
    } else {
      let flag = localStorage.getItem('showBanner');
      if (flag === 'true') {
        this.setState({showConsultbanner: true});
      } else {
        this.setState({showConsultbanner: false});
      }
    }
  }

  closeConsultBanner = () => {
    localStorage.setItem("showBanner", false);
    this.setState({showConsultbanner: false});
  }

  getUserDetailsFromTPD = () => {
    const header = {
      "X-product": "orobonds:default",
      'x-encrypted-data': true
    }
    getThirdPartyData(header).then(
      result => {
        const response = utils.parsePayload(result);
        
        if (!response || !response.success) {
          return;
        }
        this.setState({
          userEmail: response.data.email,
          name: response.data.name,
          phone: response.data.phone,
          pan : response.data.pan
        })
        // after successful login we need to identify and set the user as unique,
        // so that we can track user activities based on unique key (in our case it is Email id)
        // this implementation is for orobonds landing page.
        /* Mixpanel.set(
          { 
            '$name': this.state.name,
            '$email':this.state.userEmail
          }
        );
        Mixpanel.identify(this.state.userEmail); */
        store.dispatch(getObTPD(
          response.data
        ));
      }
    )
  }

  onComponentMount = () => {
    this.getUserDetailsFromTPD();
  }

  setUiConfig() {
    let amazonFLow = sessionStorage.getItem("instantAmount");
    var path = this.props.location && this.props.location.pathname;
    var cart = path && path.indexOf("carts/purchase") !== -1;
    var payment = path && path.indexOf("paymentMethod/purchase") !== -1;
    let config = Object.assign(
      {},
      amazonFLow && (cart || payment)
        ? { hideHeaders: true, renderHeaders: true }
        : { hideHeaders: false, renderHeaders: true }
    );
    store.dispatch(setAppConfig(config));
  }

  showMsg(msg) {
    return toast.info(msg, {
      position: toast.POSITION.TOP_LEFT,
      autoClose: false,
    });
  }

  showErrorMsg(msg) {
    return toast.error(msg, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: false,
    });
  }

  getAPIVersion = () => {
    let self = this;
    const msg =
      "We have a new update, please clear your browser's cache by press Ctrl + Shift + R";
    versionService
      .getVersion()
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        if (res.version !== "5.0.0") {
          self.setState({
            version: this.showMsg(msg),
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getPanLessHoldings() {
    userProfileService.getPanlessHoldings().then((panlessHoldings) => {
      if (panlessHoldings.constructor === Array) {
        store.dispatch(
          setUserPanlessHoldings({ panlessHoldings: panlessHoldings })
        );
      }
    });
  }

  onUserProfileClicked() {
    this.setState({
      isProfileDrawerOpen: true,
    });
  }

  // handleLogoClick() {
  //   this.setState({ loading: true, showContent: false });
  //   setTimeout(() => {
  //     window.location.replace(process.env.REACT_APP_NEUTRAL_POST_URL + '/biddeasy-dashboard/')
  //   }, 2000);
  // }

  handleLogoClick() {
    window.location.replace(process.env.REACT_APP_NEUTRAL_POST_URL + '/biddeasy-dashboard/')
  }
  
  handlePortfolioClick() {
      window.location.href = process.env.REACT_APP_NEUTRAL_POST_URL + '/portfolio';
  }

  handleReferClick() {
    window.location.replace(process.env.REACT_APP_BASE_URL_ICM +'/refer');
  }

  handleFaqClick() {
    window.location.replace(process.env.REACT_APP_NEUTRAL_POST_URL +'faq');
  }

  getPortfolio() {
    var pan = "";
    if (
      !this.state.isAllPansSelected &&
      store.getState() &&
      store.getState().user &&
      store.getState().user.defaultPanDetails &&
      store.getState().user.defaultPanDetails.length > 0
    ) {
      pan = store.getState().user.defaultPanDetails[0].pan;
    }
    const payload = {
      isAjax: true,
      pan: pan,
      Platform: "web",
      source: "iosApp",
    };
    middlewareService
      .postApiData("/ios/getPortfolio", payload)
      .then((response) => {
        // console.log("Getportfolio response:", response);
        if (response && response.success && response.success === false) {
          store.dispatch(setPortfolio({ pfLoaded: true }));
          this.showErrorMsg(
            "We are facing some issues. Please try later or refresh the page"
          );
        } else {
          if (
            response &&
            response.err &&
            response.err !== "There are no transactions for your profile"
          ) {
            this.toggle();
          }
          let tmpResponse = {};
          tmpResponse["portfolioDetails"] = response;
          store.dispatch(
            setPortfolio({
              portfolioDetails: tmpResponse.portfolioDetails,
              portfolio: portfolioHelpers.getPortfolioDetails(tmpResponse),
              isLoaded: true,
              isSummaryLoaded: true,
              pfLoaded: true,
            })
          );
        }
      });
  }

  fetchPortfolioSummary() {
    var pan = "";
    if (
      !this.state.isAllPansSelected &&
      store.getState() &&
      store.getState().user &&
      store.getState().user.defaultPanDetails &&
      store.getState().user.defaultPanDetails.length > 0
    ) {
      pan = store.getState().user.defaultPanDetails[0].pan;
    }
    middlewareService.getApiData("/ios/portfolio/summary").then((result) => {
      const response = utils.parsePayload(result);
      if (response && response.success === true && response.data) {
        let data = response.data;
        let portfolio = store.getState().portfolio.portfolio || {};
        let investmentSummary =
          (store.getState().portfolio.portfolio &&
            store.getState().portfolio.portfolio.investmentSummary) ||
          {};
        investmentSummary["yesterdaysPnlPerc"] = data.dailyPnlPerc;
        if (data) {
          investmentSummary["totalInvestment"] =
            data["mtm"] && data["mtm"].oroNumber(0, true);
        }
        portfolio["investmentSummary"] = investmentSummary;
        store.dispatch(
          setPortfolio({
            portfolioSummary: data,
            isSummaryLoaded: true,
            isLoaded:
              store.getState().portfolio && store.getState().portfolio.isLoaded,
            portfolio: portfolio,
          })
        );
      }
    });
  }

  getCartCount() {
    let hasBseAccount =
      store.getState().bse && store.getState().bse.hasBseAccount;

    let cpd =
      store.getState().user.userDetails &&
      store.getState().user.userDetails.cpd &&
      store.getState().user.userDetails.cpd[0] && store.getState().user.userDetails.cpd[0].CPD;

    let hasCpd = cpd && cpd.length;

    let bseVsMfu = BseHelpers.isCpdForMfuOrBse(
      cpd,
      store.getState().bse && store.getState().bse.hasBseAccount
    );
  }

  onUserProfileCloseClicked() {
    this.setState({
      isProfileDrawerOpen: false,
    });
  }

  redirectTo(redirectLink, data) {
    if (this.state.isProfileDrawerOpen) {
      this.onUserProfileCloseClicked();
    }

    this.props.history.push({
      pathname: redirectLink,
      state: data,
    });
  }

  openPortfolioModal() {
    this.setState({
      isUploadModalOpen: true,
    });
  }

  closePortfolioModal() {
    this.setState({
      isUploadModalOpen: false,
    });
  }

  openViewMfModal() {
    this.setState({
      isViewMfModalOpen: true,
    });
  }

  closeViewMfModal() {
    this.setState({
      isViewMfModalOpen: false,
    });
  }

  loadTransactionState() {
    var email = "";
    let checkpoints = [];
    let currentStatus = "transaction";
    userService
      .getUserStates(email, checkpoints, currentStatus)
      .then((result) => {
        const response = utils.parsePayload(result);
        if (response.success) {
          store.dispatch(
            setTransactionState({
              transactionStateArr: response.results,
              statusLoaded: true,
              nextUserState: response.currentState,
            })
          );
        }
      });
  }

  async loadAllData() {
    return userProfileService.getUserProfileDetails().then((userProfile) => {
      if (!userProfile || !userProfile.userDetails ||
        !Object.keys(userProfile.userDetails).length) {
        authService.logout();
        return;
      }
      if (userProfile) {
        store.dispatch(
          setUserDetails({
            canDetails: userProfile.canDetails,
            userDetails: userProfile.userDetails,
            validPans: userProfile.validPans,
            defaultPanDetails: this.state.isAllPansSelected
              ? [{ name: "All PANs" }]
              : userProfileHelpers.getDefaultPanDetails(
                  userProfile.validPans,
                  userProfile.userDetails.cpd.length > 0
                  ? userProfile.userDetails.cpd[0].CPD
                  : [{}]
              ),
              defaultUserDetails:
                userProfile.userDetails.cpd && userProfile.userDetails.cpd[0],
          })
        );
        this.setState({
          defaultPan:
            store.getState()?.user &&
            store.getState()?.user?.defaultPanDetails[0]?.pan,
          loader: false,
          userEmail: userProfile?.userDetails?.info?.email
        });
        // after successful login we need to identify and set the user as unique,
        // so that we can track user activities based on unique key (in our case it is Email id)
        // this implementation is for MF/Alt Asset landing page.
        /* if (this.state.userEmail) {
          Mixpanel.set(
            { 
              '$email':this.state.userEmail
            }
          );
          Mixpanel.identify(this.state.userEmail);
        } */
        return userProfile;
      }
    });
  }

  getPortfolioAccCartDetails = () => {
    this.loadAllData().then(
      (userProfile) => {
        if (userProfile) {
          this.getPortfolio();
          this.setState({ profileLoaded: true });
          // this.getBseAccount(userProfile.userDetails);
          this.getCartCount();
        } else {
          authService.logout();
        }
      }
    );
    userProfileService.setOrigin();
  }

  getKycFormData = (pan) => {
    let payload = {
      pan: pan,
      isAjax: true,
    };
    let url = "/cvlKyc/getSavedKycForm";
    let requestOptions = middlewareConstants.requestWithCredentialsJsonBSE;
    requestOptions.body = JSON.stringify(payload);
    middlewareService
      .servicePost(process.env.REACT_APP_API_URL + url, requestOptions)
      .then((resp) => {
        if (!resp || !resp.success) {
          return;
        }
        store.dispatch(
          setOnboardingKycDetails({
            kycPartial: resp.data,
            fromUserState: true,
          })
        );
      });
  };

  getCheckPoints = (pan, dob) => {
    let email =
      store.getState().user.userDetails &&
      store.getState().user.userDetails.info &&
      store.getState().user.userDetails.info.email;
    store.dispatch(
      setOnboardingDataForAddPan({
        pan: pan,
        dob: dob,
        fromUserState: true,
      })
    );
    let checkpoints = [];
    let currentStatus = "onBoarding";
    userService
      .getUserStates(email, checkpoints, currentStatus, pan)
      .then((result) => {
        const response = utils.parsePayload(result);
        if (response.success) {
          store.dispatch(
            setUserState({
              userStateArr: response.results,
              nextUserState: response.currentState,
              statusLoaded: true,
            })
          );
          if (
            response.currentState &&
            (response.currentState === "onBoardingCompletedNonKycUser" ||
              response.currentState === "onBoardingCompletedKycUser")
          ) {
            this.loadTransactionState();
          }
        }
      });
  };

  getPanAndDob(user, accounts) {
    let uccCreated = [];
    let uccPending = [];
    let incompleteSetupPans = [];
    if (accounts && accounts.length) {
      accounts.forEach((x) => {
        if (x.clientCode) {
          uccCreated.push(x);
        } else if (x.pending) {
          uccPending.push(x);
        }
      });
    }
    if (user && user.incompleteSetupPans && user.incompleteSetupPans.length) {
      incompleteSetupPans = user.incompleteSetupPans;
    }
    let pan = "",
      dob = "";
    if (uccCreated && uccCreated.length) {
      pan = uccCreated[0].pan;
      dob = uccCreated[0].dob;
    } else if (uccPending && uccPending.length) {
      pan = uccPending[0].pan;
      dob = uccPending[0].dob;
    } else if (incompleteSetupPans && incompleteSetupPans.length) {
      pan = incompleteSetupPans[incompleteSetupPans.length - 1].pan;
      dob = incompleteSetupPans[incompleteSetupPans.length - 1].dob;
    }
    return { pan, dob };
  }

  fetchTransactions() {
    var pan = "";
    var email = "";
    if (
      store.getState() &&
      store.getState().user &&
      store.getState().user.defaultPanDetails &&
      store.getState().user.defaultPanDetails.length > 0
    ) {
      pan = store.getState().user.defaultPanDetails[0].pan;
      email =
        store.getState().user.userDetails &&
        store.getState().user.userDetails.info &&
        store.getState().user.userDetails.info.email;
    }
    portfolioService
      .getTransactionHistory(
        pan,
        email,
        store.getState().bse && store.getState().bse.hasBseAccount
      )
      .then((transactions) => {
        var portfolio = store.getState().portfolio.portfolio || {};
        portfolio.investmentDetails = portfolio.investmentDetails || {
          funds: [],
          sips: [],
          timeline: {},
        };
        portfolio.investmentDetails[
          "timeline"
        ] = portfolioHelpers.getFormattedTransactions(transactions);
        store.dispatch(
          setPortfolio({
            portfolio: portfolio,
            isLoadedTimeline: true,
          })
        );
      });
  }

  setDefaultPan(panDetails) {
    this.setState(
      {
        isAllPansSelected: panDetails.pan === undefined,
        isProfileDrawerOpen: false,
        isLoaded: false,
        isLoadedTimeline: false,
        isSummaryLoaded: false,
      },
      () => {
        store.dispatch(clearPortfolio());
        store.dispatch(clearOnboarding());
        this.loadAllData();
        this.getPortfolioAccCartDetails();
        return toast.success("Success!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: true,
        });
      }
    );
  }

  onOnboardingClosed() {
    store.dispatch(clearOnboarding());
    this.loadAllData();
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  // getBseAccount = (userDetails) => {
  //   let _url = "/bse/accounts";
  //   let requestOptions = middlewareConstants.requestWithCredentials;
  //   middlewareService
  //     .serviceGet(process.env.REACT_APP_REPORTS_API_URL + _url, requestOptions)
  //     .then((response) => {
  //       let bseVsMfu = BseHelpers.isCpdForMfuOrBse(
  //         userDetails.cpd && userDetails.cpd[0] && userDetails.cpd[0].CPD,
  //         store.getState().bse && store.getState().bse.hasBseAccount
  //       );
  //       let bse = { ...store.getState().bse };
  //       if (response.success && response.result && response.result.length) {
  //         bse.data = response.result;
  //         bse.hasBseAccount = true;
  //         bse.showBseCard = false;
  //         this.getRisk(response.result[0].pan);
  //       } else {
  //         bse.hasBseAccount = false;
  //         if (
  //           userDetails &&
  //           userDetails.cpd &&
  //           userDetails.cpd[0] &&
  //           userDetails.cpd[0].CPD &&
  //           userDetails.cpd[0].CPD.length &&
  //           bseVsMfu.isMfuUser
  //         ) {
  //           bse.showBseCard = false;
  //         } else {
  //           bse.showBseCard = true;
  //         }
  //         let risk = {
  //           showRiskCard: false,
  //           riskLoaded: true,
  //         };
  //         store.dispatch(setRiskProfile(risk));
  //       }
  //       let incompletePans =
  //         userDetails && userDetails.incompleteSetupPans
  //           ? userDetails.incompleteSetupPans
  //           : [];
  //       let { pan, dob } = this.getPanAndDob(userDetails, response.result);
  //       if (incompletePans.length > 0) {
  //         this.getKycFormData(pan);
  //         this.getCheckPoints(pan, dob);
  //       } else {
  //         this.getCheckPoints(pan, dob);
  //       }
  //       store.dispatch(setBse(bse));
  //     });
  // };

  checkIfESignDone = (data) => {
    let pans = data.map((item) => item.pan);
    esigningUrl.checkIfESignDone(pans).then((result) => {
      let showEsignCard =
        result.some((item) => item.data && !item.data.eSigningDone) || false;
      store.dispatch(
        setUserState({
          showEsignCard,
          data: result,
        })
      );
    });
  };

  getShoppingGoals = () => {
    store.dispatch(setShoppingGoals({ loading: true, loadingTimeline: true }));
    festGoalsService.getShoppingGoals().then((response) => {
      if (response && response.length) {
        let goals = response.filter((goal) => goal.txns && goal.txns.length);
        if (goals && goals.length) {
          this.getGoalDetails(goals[goals.length - 1]);
        } else {
          store.dispatch(
            setShoppingGoals({
              goalPresent: false,
              loading: false,
              loadingTimeline: false,
              emptyTimeline: true,
            })
          );
        }
      } else {
        store.dispatch(
          setShoppingGoals({
            loading: false,
            loadingTimeline: false,
            emptyTimeline: true,
          })
        );
      }
    });
  };

  getGoalDetails = (goal) => {
    if (goal && goal.goalId) {
      let festId = process.env.REACT_APP_FESTIVAL_ID
        ? process.env.REACT_APP_FESTIVAL_ID
        : "test";
      let payload = {
        festId: festId,
        goalId: goal.goalId,
      };
      festGoalsService.getGoalDetails(payload).then((response) => {
        if (response && response.txns && response.txns.length) {
          store.dispatch(
            setShoppingGoals({
              transaction: response.txns,
              emptyTimeline: false,
              loadingTimeline: false,
              goalId: response.goalId,
            })
          );

          let goalProcessed = false;
          response.txns.map((txn) => {
            if (txn.status === "RP") {
              goalProcessed = true;
            }
          });

          if (!goalProcessed) {
            store.dispatch(
              setShoppingGoals({
                loadTrackOrder: true,
                goalPresent: true,
                loading: false,
              })
            );
          } else {
            this.getMTM(response);
          }
        } else {
          store.dispatch(
            setShoppingGoals({
              emptyTimeline: true,
              loadingTimeline: false,
            })
          );
        }
      });
    }
  };

  getMTM = (goal) => {
    let festId = process.env.REACT_APP_FESTIVAL_ID
      ? process.env.REACT_APP_FESTIVAL_ID
      : "test";
    let payload = {
      festId: festId,
      goalId: goal.goalId,
    };

    festGoalsService.getMTM(payload).then((response) => {
      if (response) {
        store.dispatch(
          setShoppingGoals({
            goalProcessed: true,
            goalPresent: true,
            pf: response,
            goalId: goal.goalId,
            loadTrackOrder: false,
            loading: false,
          })
        );

        let tmpResponse = {};
        tmpResponse["portfolioDetails"] = response;
        store.dispatch(
          setAmazonGoalData({
            portfolioDetails: tmpResponse.portfolioDetails,
            portfolio: portfolioHelpers.getPortfolioDetails(tmpResponse),
            isLoaded: true,
            isSummaryLoaded: true,
            pfLoaded: true,
          })
        );
      }
    });
  };

  // getRisk = (pan) => {
  //   riskService.getRiskFromPAN(pan).then((resp) => {
  //     let risk = { ...store.getState().riskProfiler };
  //     if (resp && resp.success && resp.risk !== 0) {
  //       risk.risk = resp.risk;
  //       risk.pan = pan;
  //       risk.showRiskCard = false;
  //       risk.riskLoaded = true;
  //     } else {
  //       risk.pan = pan;
  //       risk.showRiskCard = true;
  //       risk.riskLoaded = true;
  //     }
  //     store.dispatch(setRiskProfile(risk));
  //   });
  // };

  openRiskModal = () => {
    this.setState({
      openRiskModal: true,
    });
    this.onUserProfileCloseClicked();
  };

  toggleRiskModal = () => {
    this.setState({
      openRiskModal: !this.state.openRiskModal,
    });
  };

  render() {
    window.onhashchange= () => {
      this.onComponentMount();
    }
    let isorobonds = (window.location.hash.split('#')[1]).split('-')[0];
    var storeState = store.getState();
    let redirectLocation = localStorage.getItem("redirectedFrom");
    let isMfuUser =
      storeState.user &&
      storeState.user.userDetails &&
      storeState.user.userDetails.isMfuUser;
    if (redirectLocation) {
      localStorage.removeItem("redirectedFrom");
      localStorage.removeItem("redirectionSet");
      return (
        <Redirect
          to={{
            pathname:
              redirectLocation !== null && redirectLocation !== "/null"
                ? redirectLocation
                : "/",
            state: { from: this.props.location },
          }}
        />
      );
    }
    let isBondsDocvault = (window.location.hash.split('#')[1]) === "/biddeasy-docvault" ||
    (window.location.hash.split('#')[1]) === "/biddeasy-profile" || (window.location.hash.split('/')[1]) === "biddeasy-asset";
    const searchParms = new URL(window.location.href);
    return (
      <>
      {/* {this.state.loading ? (<MainLoader/>): */}
      <div
        className={classnames("h-100", {
          "profile-drawer-opened": this.state.isProfileDrawerOpen,
        })}
      >                
        {this.state.isNativeView || 
          (searchParms['hash'] && searchParms['hash'].includes('partner=icmAdvisory')) ? null :
        <Header
          onUserProfileClicked={this.onUserProfileClicked}
          {...storeState.setAppConfig}
          isAmazon={window.$isAmazon}
          isPremiumUser= {storeState?.user?.userDetails?.premiumUser}
          isOrobonds={ isorobonds === '/biddeasy' }
          history={this.props.history}
          userEmail={this.state.userEmail}
          handleLogoClick={this.handleLogoClick}
          handleReferClick={this.handleReferClick}
          handlePortfolioClick={this.handlePortfolioClick}
          handleFaqClick={this.handleFaqClick}
          loading={this.state.loading}
          userType={this.state.userType}
          pan={this.state.pan}
        />}
        
        <Container className="h-100 container-fluid">
        <Switch>
          <Route exact path="/referral-dashboard" component={ReferMain} />
          <Route exact path="/liquidation" component={LiquidationMain} />
          <Route 
            exact 
            path="/biddeasy-asset/:productType/:product/redeem/:order?"
            render={() => 
              <LiquidationMain 
                userEmail={this.state.userEmail}
                phone={this.state.phone}
              />            
            }
          />
          <Route exact path="/refer-dashboard" component={ReferralDashboardMain} />
          <Route
            exact
            path="/portfolio"
            component={OrobondsPortfolioMain}
          />
          <Route
            exact
            path="/biddeasy-docvault/:tab"
            component={WaitlistDocsUpMain}
          />
          <Route
            exact
            path="/biddeasy-docvault"
            component={WaitlistDocsUpMain}
          /> 
          <Route 
            exact 
            path="/biddeasy-asset/:productType/:product"
            render={() => 
              <OrobondsAsset 
                userEmail={this.state.userEmail}
                showConsultbanner={this.state.showConsultbanner}
                closeConsultBanner={this.closeConsultBanner}
                isUserObInvested={this.state.isUserObInvested}
                pan={this.state.pan}
              />            
            }
          />
          <Route 
            exact 
            path="/biddeasy-asset/:productType/:queryParams?"
            render={(props) => (
              <OrobondsAsset 
                {...props}
                userEmail={this.state.userEmail}
                showConsultbanner={this.state.showConsultbanner}
                closeConsultBanner={this.closeConsultBanner}
                isUserObInvested={this.state.isUserObInvested}
                pan={this.state.pan}
              />
            )}
          />
          <Route 
            exact 
            path="/biddeasy-profile"
            component={OrobondsProfile}
          />
          <Route
            exact
            path="/biddeasy-reports"
            component={IncReports}
          />

          <Route 
            exact 
            path="/refer"
            component={ReferDashboard}
          />
           <Route 
            exact 
            path="/biddeasy-faq"
            component={OrobondsFaqs}
          />
          <Route 
            exact 
            path="/biddeasy-portfolio"
            component={OrobondsPortfolioMain}
          />
          <Route
            exact
            path="/faq"
            component={SeprateFaq}
          />
          <Route 
            exact 
            path="/biddeasy-investment-opportunities"
            component={ObInvestmentOpportunitiesMain}
          />
          <Route 
            exact 
            path="/biddeasy-dashboard/:tab?"
            render={(props) => (
              <OrobondsMain
                {...props}
                portfolioDetails={this.state.portfolioDetails}
                userEmail={this.state.userEmail}
                name={this.state.name}
                navBarRef={this.navBarRef}
                showConsultbanner={this.state.showConsultbanner}
                closeConsultBanner={this.closeConsultBanner}
                pan={this.state.pan}
              />
            )}
          />
          <Route
            exact
            path="/:link?"
            render={(props) => (
              <OrobondsMain
              {...props}
              portfolioDetails={this.state.portfolioDetails}
              userEmail={this.state.userEmail}
              name={this.state.name}
              navBarRef={this.navBarRef}
              pan={this.state.pan}
            />
            )}
          />
          </Switch>
            <UserProfileDrawerBse
              onUserProfileCloseClicked={this.onUserProfileCloseClicked}
              show={this.state.isProfileDrawerOpen}
              redirectTo={this.redirectTo}
              openPortfolioModal={this.openPortfolioModal}
              openViewMfModal={this.openViewMfModal}
              onDefaultPanSelected={this.setDefaultPan}
              onOnboardingClosed={this.onOnboardingClosed}
              openRiskModal={this.openRiskModal}
              isOrobonds={ isorobonds === '/biddeasy' }
              history={this.props.history}
              pan={this.state.pan}
          />
        </Container>
      
        
        {(this.state.isNativeView || (searchParms['hash'] && searchParms['hash'].includes('partner=icmAdvisory'))) ? null : 
          <MobileMenu
            {...storeState.setAppConfig}
            isAmazon={window.$isAmazon}
            location={this.props.location}
            isPremiumUser= {storeState?.user?.userDetails?.premiumUser}
            isOrobonds={ isorobonds === '/biddeasy' }
            onUserProfileCloseClicked={this.onUserProfileCloseClicked}
            onUserProfileClicked={this.onUserProfileClicked}
            userType={this.state.userType}
            isProfileDrawerOpen={this.state.isProfileDrawerOpen}
            handleLogoClick={this.handleLogoClick}
            handleReferClick={this.handleReferClick}
            handlePortfolioClick={this.handlePortfolioClick}
            pan={this.state.pan}
          />
        }
        <ToastContainer />
      </div>
      {/* } */}
      </>
    );
  }
}

export default AppShell;
